import React, { useEffect, useState, useRef } from 'react';
import searchIcon from '../../../../assets/images/busca-preto.svg';
import forwardIcon from '../../../../assets/images/fast-forward.svg';
/* import searchIcon from '../../../../../../../assets/images/busca-preto.svg'; */

export default function QuickAccessSearch({
  searchList,
  setSearchList,
  menuList,
  setMenuList,
  quickAccessList,
  maxNumberItens,
}) {
  const [openSearchBox, setOpenSearchBox] = useState(false);
  const SearchWrapperRef = useRef(null);

  useEffect(() => {
    // eslint-disable-next-line no-use-before-define
    document.addEventListener('click', onClickOutsideComponent, false);
    return () => {
      // eslint-disable-next-line no-use-before-define
      document.removeEventListener('click', onClickOutsideComponent, false);
    };
  }, []);

  const handleClickItem = (item) => {
    const limit = maxNumberItens || 10;
    setMenuList([...menuList, item].slice(0, limit));
  };

  const handleSearchOnToggle = () => {
    setOpenSearchBox(!openSearchBox);
  };

  const handleForwardButton = () => {
    const limit = maxNumberItens || 10;
    setMenuList([...menuList, ...searchList].slice(0, limit));
  };

  const handleSearchInput = (value) => {
    const pattern = new RegExp(value, 'gi');
    const standSearch = quickAccessList.filter((item) => {
      return !menuList.includes(item) ? item.title.match(pattern) : false;
    });
    setSearchList(standSearch);
  };

  const onClickOutsideComponent = (event) => {
    if (
      SearchWrapperRef.current &&
      !SearchWrapperRef.current.contains(event.target)
    ) {
      setOpenSearchBox(false);
    }
  };

  return (
    <div
      className="quick-access-search-bar-container"
      onFocus={handleSearchOnToggle}
      ref={SearchWrapperRef}
    >
      <div className="quick-access-search-bar">
        <div className="quick-access-search-img">
          <img src={searchIcon} alt="Lupa" />
        </div>
        <input
          id="tags-report-input"
          type="text"
          placeholder="Buscar Item"
          onChange={(e) => {
            handleSearchInput(e.target.value);
          }}
        />
        <div className="quick-access-search-img forward-icon">
          <img
            className="forward-icon-img"
            src={forwardIcon}
            alt="Forward"
            onClick={handleForwardButton}
          />
        </div>
      </div>
      <div
        className="quick-access-search-found-itens"
        style={
          openSearchBox ? { display: 'inline-block' } : { display: 'none' }
        }
      >
        {searchList
          ? searchList.map((item, index) => {
              return (
                <div
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  onClick={() => {
                    handleClickItem(item);
                  }}
                  className="search-item-found"
                >
                  <div className="item-found-title" title={item.title}>
                    {item.title.length > 35
                      ? `${item.title.substring(0, 34)}...`
                      : item.title}
                  </div>
                </div>
              );
            })
          : ''}
      </div>
    </div>
  );
}